import React from "react";
import DelayedFadeIn from "./DelayedFadeIn";

interface TypingGreetingProps {
  showBigChatBox: boolean;
}

const TypingGreeting: React.FC<TypingGreetingProps> = React.memo(({ showBigChatBox }) => {
  const rotatingWords = [
    "features?",
    "user stories?",
    "work items?",
    "epics?",
    "tasks?",
    "stories?",
    "timelines?",
    "epics?"
  ];

  // CSS for the responsive sliding animation
  const slidingTextStyles = `
    .sliding-text-container {
      display: ${showBigChatBox ? 'inline-block' : 'block'};
      height: 1.2em;
      overflow: hidden;
      vertical-align: baseline;
      text-align: ${showBigChatBox ? 'left' : 'center'};
      width: auto;
      min-width: ${showBigChatBox ? '200px' : '120px'};
      max-width: ${showBigChatBox ? '280px' : '250px'};
    }
    
    .sliding-text-list {
      margin: 0;
      padding: 0;
      list-style: none;
      animation: slideChange 16s linear infinite;
      width: max-content;
      ${!showBigChatBox ? 'margin: 0 auto;' : ''}
    }
    
    .sliding-text-item {
      line-height: 1.2em;
      margin: 0;
      font-weight: 900;
      color: #3b82f6;
    }
    
    .dark .sliding-text-item {
      color: #60a5fa;
    }
    
    @keyframes slideChange {
      0%, 12.5%, 100% { transform: translate3d(0, 0, 0); }
      14.28%, 26.78% { transform: translate3d(0, -12.5%, 0); }
      28.56%, 41.06% { transform: translate3d(0, -25%, 0); }
      42.84%, 55.34% { transform: translate3d(0, -37.5%, 0); }
      57.12%, 69.62% { transform: translate3d(0, -50%, 0); }
      71.4%, 83.9% { transform: translate3d(0, -62.5%, 0); }
      85.68%, 98.18% { transform: translate3d(0, -75%, 0); }
    }
  `;

  return (
    <>
      <style>{slidingTextStyles}</style>
      {showBigChatBox ? (
        <DelayedFadeIn delay={300}>
          <h3 className="font-black text-gray-800 dark:text-white transition-all duration-500 leading-tight flex items-center flex-nowrap" style={{
            fontWeight: '900',
            fontSize: 'clamp(1.2rem, 4vw, 2.2rem)'
          }}>
            <span className="inline-block whitespace-nowrap">How can I assist you with your</span>

            <div className="sliding-text-container ml-2 sm:ml-3">
              <ul className="sliding-text-list">
                {rotatingWords.map((word, index) => (
                  <li key={index} className="sliding-text-item">
                    {word}
                  </li>
                ))}
              </ul>
            </div>
          </h3>
        </DelayedFadeIn>
      ) : (
        <DelayedFadeIn delay={300}>
          <div className="font-black text-gray-800 dark:text-white transition-all duration-500 leading-tight text-center flex flex-col items-center" style={{
            fontWeight: '900',
            fontSize: 'clamp(1.125rem, 3vw, 1.5rem)'
          }}>
            <div className="whitespace-nowrap mb-1">How can I assist you with your</div>

            <div className="sliding-text-container">
              <ul className="sliding-text-list">
                {rotatingWords.map((word, index) => (
                  <li key={index} className="sliding-text-item">
                    {word}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </DelayedFadeIn>
      )}
    </>
  );
});

export default TypingGreeting;